export * from './IconCHF';
export * from './IconEUR';
export * from './IconGBP';
export * from './IconUSD';
